export function selectJobGeneratorCards() {
  const cards = document.querySelectorAll('.js-jobGeneratorCards');
  const buttonMobile = document.querySelector('.js-result-button');
  const isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  cards.forEach((card) => {
    const cardNormal = card.querySelector('.js-card');
    const cardHover = card.querySelector('.js-card-hover');

    card.addEventListener('click', () => {
      const isActive = card.classList.contains('card--active');

      if (!isActive) {
        card.classList.add('card--active');
        cardNormal?.classList.add('hide');
        cardHover?.classList.remove('hide');
      } else {
        cardNormal?.classList.remove('hide');
        cardHover?.classList.add('hide');
        card.classList.remove('card--active');
      }

      const button = card.querySelector('.js-jobGeneratorButton');
      button?.classList.toggle('card__buttonSquare');
      const activeCard = document.querySelector('.card--active');
      if (activeCard) {
        buttonMobile?.classList.remove('button--jobGeneratorDeactivated');
      } else {
        buttonMobile?.classList.add('button--jobGeneratorDeactivated');
      }
    });

    if (!isMobile) {
      card.addEventListener('mouseenter', () => {
        if (!card.classList.contains('card--active')) {
          cardNormal?.classList.add('hide');
          cardHover?.classList.remove('hide');
          card.classList.add('card--hover');
        }
      });

      card.addEventListener('mouseleave', () => {
        if (!card.classList.contains('card--active')) {
          cardNormal?.classList.remove('hide');
          cardHover?.classList.add('hide');
          card.classList.remove('card--hover');
        }
      });
    }
  });
}
